'use strict'

import { axiosGet } from '../../axios/axios.js'
import PreviousDeferredReportWarning from './PreviousDeferredReportWarning.vue'

const SO_WORK_AREA_KEYS = ['SO', 'СО']

export function hasSoWorkArea (workAreas) {
  if (!workAreas) {
    return false
  }
  const list = Array.isArray(workAreas) ? workAreas : [workAreas]
  return list.some(workArea => {
    const key = workArea && typeof workArea === 'object' ? (workArea.key || workArea.id) : workArea
    return SO_WORK_AREA_KEYS.includes(key)
  })
}

export function isSoRequest (request) {
  if (!request) {
    return false
  }
  return hasSoWorkArea(request.workAreas) || hasSoWorkArea(request.assigneeWorkAreas)
}

export function getDepartureReport (request) {
  const reportId = request && request.departureReportId
  if (!reportId || !request.reports || !request.reports.length) {
    return null
  }
  return request.reports.find(report => report.id === reportId) || null
}

export function shouldBlockReportOpen (request) {
  if (!isSoRequest(request)) {
    return false
  }
  const report = getDepartureReport(request)
  return !!(report && report.hasPreviousDeferredReport)
}

export function shouldBlockLoadedReport (request, report) {
  return !!(isSoRequest(request) && report && report.hasPreviousDeferredReport)
}

function findDeferredReportOnRequest (request) {
  if (!request || !request.reports || !request.reports.length) {
    return null
  }
  return request.reports.find(report => report.deferred === true) ||
    request.reports.find(report => report.id === request.departureReportId && report.stateId === 'PR11') ||
    null
}

export function getDeferredReportWarningData (store) {
  const list = store && store.getters && store.getters.getDeferredReportRequests || []
  let matchRequest = null
  let matchReport = null

  const request = list.find(request => findDeferredReportOnRequest(request))
  matchRequest = request || matchRequest
  matchReport = matchRequest ? findDeferredReportOnRequest(matchRequest) : matchReport

  if (!matchRequest && list[0]) {
    matchRequest = list[0]
    matchReport = getDepartureReport(list[0])
  }

  if (!matchRequest) {
    return {
      deferredRequestId: null,
      deferredReportId: null,
      deferredReportNumber: ''
    }
  }

  return {
    deferredRequestId: matchRequest.id,
    deferredReportId: matchReport && matchReport.id || matchRequest.departureReportId || null,
    deferredReportNumber: matchRequest.objectNumber || matchRequest.objectAlias || ''
  }
}

export function showPreviousDeferredReportWarning (vm, data) {
  const warningData = data || getDeferredReportWarningData(vm.$store)
  const to = warningData.deferredRequestId && warningData.deferredReportId
    ? '/task/' + warningData.deferredRequestId + '/document/' + warningData.deferredReportId
    : null

  const dialog = vm.$d.dialog(vm).show({
    contentComponent: PreviousDeferredReportWarning,
    headerLabel: 'Внимание',
    contentProps: {
      objectNumber: warningData.deferredReportNumber || '',
      to,
      onLinkClick: () => {
        if (dialog) {
          dialog.hide()
        }
      },
      close: () => {
        if (dialog) {
          dialog.hide()
        }
      }
    }
  })
  return dialog
}

export function checkPreviousDeferredReportBlock (vm, request) {
  if (!shouldBlockReportOpen(request)) {
    return false
  }
  showPreviousDeferredReportWarning(vm)
  return true
}

export function checkDeferralAccess (report) {
  if (report.actionsAccess.deferReport) {
    return Promise.resolve({
      deferReportCommon: true,
      deferReport: true
    })
  }

  return axiosGet({
    url: '/service/delta/report/checkDeferralAccess?id=' + report.id,
    onSuccess: (response) => response.data,
    onFailure: () => {
      return {
        // deferReportCommon: false,
        deferReport: false
      }
    }
  })
}
